import { Flex } from '@chakra-ui/layout'
import { Image as ChakraImage } from '@chakra-ui/react'
import { Image as ReactPDFImage, View } from '@react-pdf/renderer'
import { MenuTemplateEnum } from '../../__generated__/graphql'
import { StoreCreatePubMenu } from '../pages/pub-menu/create/StoreCreatePubMenu'

type Props = {
  children: React.ReactNode
  type: 'builder' | 'pdf'
  store: StoreCreatePubMenu
}

export const CoverPageTextDecorator: React.FC<Props> = ({
  children,
  type,
  store,
}) => {
  if (
    store.settings.template.name === MenuTemplateEnum.Timisoreana1 ||
    store.settings.template.name === MenuTemplateEnum.Timisoreana2 ||
    store.settings.template.name === MenuTemplateEnum.Timisoreana3
  ) {
    if (type === 'builder') {
      return (
        <Flex position="relative" flexDirection="column" alignItems="center">
          <ChakraImage
            src={`/img/templates/layout/${store.settings.template.name}/title_deco_top.png`}
            w={75}
            h="auto"
            objectFit="contain"
            position="absolute"
            top={-14}
            alt={`${store.settings.template.name} decoration top`}
          />
          {children}
          <ChakraImage
            src={`/img/templates/layout/${store.settings.template.name}/title_deco_bottom.png`}
            w={75}
            h="auto"
            objectFit="contain"
            position="absolute"
            bottom={-4}
            alt={`${store.settings.template.name} decoration bottom`}
          />
        </Flex>
      )
    }

    if (type === 'pdf') {
      return (
        <View
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <ReactPDFImage
            src={`/img/templates/layout/${store.settings.template.name}/title_deco_top.png`}
            style={{
              width: 75,
              height: 'auto',
              objectFit: 'contain',
              position: 'absolute',
              top: -54,
            }}
          />
          {children}
          <ReactPDFImage
            src={`/img/templates/layout/${store.settings.template.name}/title_deco_bottom.png`}
            style={{
              width: 75,
              height: 'auto',
              objectFit: 'contain',
              position: 'absolute',
              bottom: -14,
            }}
          />
        </View>
      )
    }
  }

  return <>{children}</>
}
